<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14A7Wvh/tc-custom/9781609254896.jpg?1728353491886" alt="This image is the cover for the book Esoteric Orders and Their Work"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Esoteric Orders and Their Work
      </h1>
      <p class="bookDescription body article font2">
        <b>From the British occultist and author, a classic study of what esoteric orders are and what they can offer initiates.</b><br/><br/>People have been interested in secret traditions since the beginning of time. Fraternal brotherhoods and sisterhoods, and secret orders of varying degrees exist in every country, race, and religion.<br/><br/>In <i>Esoteric Orders and Their Work</i>, author Dion Fortune gets to the root of exactly what esoteric orders are, leaving no stone unturned. The chapter “Esotericism, Occultism, and Mysticism” defines what esotericism is in relation to exotericism—in layman’s terms, the inner life versus the outer one. In “The Origin of the Mysteries,” she looks at how esotericism grew hand-in-hand with the evolution of humankind, discussing how humans evolved from a group soul (still present in animals today, i.e.: packs of wolves) into a singular soul. “The Paths of the Western Tradition” is a discussion on the different schools that have developed (known as Rays) and how students, after having formed a solid base of knowledge, work through each ray on their way to becoming closer to an esoteric ideal. She expounds upon Masters in “The Evolution and Functions of the Masters.” We discover that they are not so much superhuman entities as beings who have learned all they need to know on the physical plane and now teach from the ethereal. Chapters such as “The Right and Left-Hand Paths” and “The Use and Power of Ritual” explain the differences between Black and White Occultism, and how long-kept-secret rituals taught only to initiates are used to further the order’s members along their paths.<br/><br/>Today, in the centers of the civilized world, there is renewed interest in esoteric schools, and although they may be misunderstood by the mainstream, some of the noblest people have been among their advocates. This book removes the shroud of mystery and fear from esotericism and makes the Western Mystery Tradition accessible to anyone who has ever been curious about this fascinating spiritual path!<br/><br/><b>Revised edition contains a new foreword by Gareth Knight, and an index.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dion Fortune, Gareth Knight
      </h2>
      
      <p class="authorDescription body article">Dion Fortune (1891-1946), founder of The Society of the Inner Light, is recognized as one of the most luminous figures of 20th-century esoteric thought. A prolific writer, pioneer psychologist, powerful psychic, and spiritualist, she dedicated her life to the revival of the Western Mystery Tradition. She was also a member of the Order of the Golden Dawn, whose members included at various times such people as A.E. Waite, Aleister Crowley, and W.B. Yeats.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Samuel Weiser, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?316a179d